import type { Tool } from "./Tool";

/**
 * A no-op tool that just lets OrbitControls do its thing. Having it in the
 * toolbar makes "rotate the camera" an explicit mode rather than a side
 * effect of deselecting other tools.
 */
export class OrbitTool implements Tool {
  readonly id = "orbit";
  readonly name = "Orbit";
  readonly hint = "Drag to rotate the view. Right-drag pans, scroll to zoom.";
  readonly icon = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <ellipse cx="12" cy="12" rx="10" ry="4" />
      <ellipse cx="12" cy="12" rx="10" ry="4" transform="rotate(60 12 12)" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" />
    </svg>`;
}
